import {DI, DI_VARIATIONS} from '../types'
import {ContainerModule, ContainerModuleLoadOptions, ResolutionContext} from 'inversify'

import {StorageAdapter} from '@/src/core/domain/data/storage'

import {LocalStorage, MobileStorage} from '@/src/infrastructure/data/storage'

import {isMobile} from '@/src/shared/utils/functions'

const initializeModule = ({bind}: ContainerModuleLoadOptions) => {
  bind<StorageAdapter>(DI_VARIATIONS.MobileStorage).to(MobileStorage)
  bind<StorageAdapter>(DI_VARIATIONS.LocalStorage).to(LocalStorage)

  bind<StorageAdapter>(DI.StorageAdapter)
    .toDynamicValue((context: ResolutionContext) => {
      if (isMobile() && process.env.NODE_ENV === 'production') {
        return context.get<StorageAdapter>(DI_VARIATIONS.MobileStorage)
      }
      return context.get<StorageAdapter>(DI_VARIATIONS.LocalStorage)
    })
    .inRequestScope()
}

export const StorageModule = new ContainerModule(initializeModule)
